export const TITLE = 'Turun Flamenco ry'
export const TOKEN = 'eebd9b0dbf726eb76b5e2dcbfa07d0'
export const URL = 'https://www.turunflamenco.fi'
export const API = '/backend/api'
export const PATH = '/backend/storage/uploads'
